
import Vue from "vue";
import { get_candidate_pools } from "@/store/apis/recruiter";

interface ExistingPool {
  id: string;
  name: string;
  candidateCount: number;
}

export default Vue.extend({
  name: "PoolSelection",
  props: {
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selectedPoolId: this.value,
      existingPools: [] as ExistingPool[],
      loadingPools: false
    };
  },
  computed: {
    poolRules() {
      const rules = [];
      if (this.required) {
        rules.push((value: string) => !!value || this.$t('recruiter.post-job.pool-selection.required'));
      }
      return rules;
    }
  },
  watch: {
    value(newVal) {
      this.selectedPoolId = newVal;
    },
    selectedPoolId(newVal) {
      this.$emit('input', newVal);
    }
  },
  async mounted() {
    await this.loadExistingPools();
  },
  methods: {
    async loadExistingPools() {
      this.loadingPools = true;
      try {
        const response = await get_candidate_pools();
        
        // Check for success using statusCode (200) and data array
        if (response.data && response.data.statusCode === 200 && response.data.data) {
          // Transform API response to match our interface
          this.existingPools = response.data.data.map((pool: any) => ({
            id: pool.id.toString(), // Convert to string for consistency
            name: pool.pool_name,
            candidateCount: pool.candidate_count || 0
          }));
        } else {
          // Fallback to empty array if API fails
          this.existingPools = [];
        }
      } catch (error) {
        console.error('Error loading existing pools:', error);
        // Fallback to empty array on error
        this.existingPools = [];
      } finally {
        this.loadingPools = false;
      }
    },
    onPoolChange(poolId: string) {
      this.$emit('pool-selected', poolId);
    }
  }
});
